
































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import Logo from "@/shared/components/Logo.vue";
import PartnerFooter from "@/shared/components/PartnerFooter.vue";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Logo,
    PartnerFooter
  }
})
export default class LoginWrapper extends Vue {
  @Prop({ default: true }) showBottomGraphic: boolean;
  @Prop({ default: true }) showFooter: boolean;
  @Prop({ default: false }) hideLogo: boolean;
  @Prop({ default: 4 }) colXlSize: number;
  @Prop({ default: 4 }) colLgSize: number;
  @Prop({ default: 6 }) colMdSize: number;
  @Prop({ default: false }) useIndividualSignupHeader: boolean;

  userStore = useUserStore();

  get canShowLogo () {
    return this.hideLogo === false;
  }
}
